import React, { useState, useEffect } from "react";
import Slider from "../components/sidebar";
import ErrorModal from "../components/error";
import ServerURL from "../server/serverUrl";
import { ImagePathRoutes } from '../routes/imagePathRoutes';
import SuccessModal from "../components/sucessmodel";
import { useParams, useNavigate } from "react-router-dom";
import { fetchSelectBrand } from "../services/addBrand";
import { fetchSelectCategory, fetchSelectsubCategoryid, fetchProductIdAdmin, insertProduct } from "../services/addproducts";
import { 
  Package, Save, Upload, Tag, DollarSign, 
  Layers, Loader2, Box, Plus, Trash2
} from "lucide-react";

const ToggleSwitch = ({ checked, onChange, label }) => (
  <div onClick={onChange} className="flex items-center justify-between py-1.5 px-3 bg-gray-50 rounded-lg hover:bg-gray-100 cursor-pointer transition-all duration-200">
    <span className="text-sm font-medium text-gray-700">{label}</span>
    <div className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors duration-200 ${checked ? 'bg-blue-600' : 'bg-gray-300'}`}>
      <span className={`inline-block h-3.5 w-3.5 transform rounded-full bg-white shadow-md transition-transform duration-200 ${checked ? 'translate-x-4' : 'translate-x-0.5'}`} />
    </div>
  </div>
);

const Input = ({ label, value, onChange, type = "text", required = false, icon: Icon, placeholder, className = "", maxLength, inputMode }) => {
  const handleChange = (e) => {
    let newValue = e.target.value;
    if (type === "number") {
      newValue = newValue.replace(/[^0-9.]/g, '');
      const parts = newValue.split('.');
      if (parts.length > 2) {
        newValue = parts[0] + '.' + parts.slice(1).join('');
      }
    }
    if (maxLength && newValue.length > maxLength) {
      newValue = newValue.slice(0, maxLength);
    }
    onChange(newValue);
  };

  return (
    <div className={className}>
      <label className="flex text-xs font-semibold text-gray-700 mb-1 items-center gap-1">
        {Icon && <Icon className="w-3 h-3 text-blue-600" />}
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <input
        type={type}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        maxLength={maxLength}
        inputMode={inputMode}
        className="w-full px-2 py-1.5 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1.5 focus:ring-blue-500 focus:border-transparent"
        required={required}
      />
    </div>
  );
};

const Select = ({ label, value, onChange, options, required = false, icon: Icon, className = "" }) => (
  <div className={className}>
    <label className="flex text-xs font-semibold text-gray-700 mb-1 items-center gap-1">
      {Icon && <Icon className="w-3 h-3 text-blue-600" />}
      {label} {required && <span className="text-red-500">*</span>}
    </label>
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="w-full px-2 py-1.5 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1.5 focus:ring-blue-500 focus:border-transparent appearance-none bg-white"
    >
      <option value="">Select {label}</option>
      {options.map((item) => (
        <option key={item.Id || item.value} value={item.Id || item.value}>
          {item.Category || item.SubCategory || item.BrandName || item.label || item}
        </option>
      ))}
    </select>
  </div>
);

const AddProductForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const sanitizeMultiplePriceList = (list) => {
    if (!Array.isArray(list)) return [];
    return list.filter(item => item && typeof item === 'object');
  };
  
  // Form states
  const [productCode, setProductCode] = useState('');
  const [productName, setProductName] = useState('');
  const [tamilName, setTamilName] = useState('');
  const [categoryid, setCategoryid] = useState('');
  const [selectedCategory, setSelectedCategory] = useState("");
  const [mrp, setMrp] = useState('');
  const [saleRate, setSaleRate] = useState('');
  const [selectedUOM, setSelectedUOM] = useState("Kgs");
  
  // Multiple Price states
  const [multiplePriceEnabled, setMultiplePriceEnabled] = useState(false);
  const [multiplePriceList, setMultiplePriceList] = useState([]);
  const [weightType, setWeightType] = useState('');
  const [mrp2, setMrp2] = useState('');
  const [saleRate2, setSaleRate2] = useState('');
  
  // Additional states
  const [productDescription, setProductDescription] = useState('');
  const [activeStatus, setActiveStatus] = useState(true);
  const [offerProduct, setOfferProduct] = useState(false);
  const [newProduct, setNewProduct] = useState(false);
  const [featureProduct, setFeatureProduct] = useState(false);
  const [inStock, setInStock] = useState(true);
  const [returnsavailability, setReturnsavailability] = useState(false);
  const [returnsavailabilityDate, setReturnsavailabilityDate] = useState('');
  const [AproximiateDate, setAproximiate] = useState('');
  const [ourchoice, setOurchoice] = useState(false);
  
  // Brand & Category
  const [Brand, setBrand] = useState([]);
  const [category, setCategory] = useState([]);
  const [dsubcategory, setSubCategoryd] = useState([]);
  const [BrandId, setBrandId] = useState(null);
  const [selectedBrand, setSelectedBrand] = useState('');
  
  // Images
  const [mainImage, setMainImage] = useState(null);
  const [AdditionalImage, setAdditionalImage] = useState(null);
  const [AdditionalImage1, setAdditionalImage1] = useState(null);
  const [mainImagePreview, setMainImagePreview] = useState(null);
  const [additionalImagePreview, setAdditionalImagePreview] = useState(null);
  const [additionalImage1Preview, setAdditionalImage1Preview] = useState(null);
  
  // UI States
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [adminId, setAdminId] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);

  var Comid = JSON.parse(localStorage.getItem("adminuserid"));

  useEffect(() => {
    const adminUserId = JSON.parse(localStorage.getItem("adminuserid"));
    if (!adminUserId) {
      alert("Session Closed. Please Login Again!");
      setTimeout(() => navigate("/"), 2000);
    } else {
      setAdminId(Number(adminUserId));
    }
  }, [navigate]);

  useEffect(() => {
    if (adminId) {
      setLoading(true);
      Promise.all([
        fetchSelectBrand(adminId),
        fetchSelectCategory(adminId)
      ]).then(([brandData, categoryData]) => {
        if (Array.isArray(brandData)) setBrand(brandData);
        if (Array.isArray(categoryData)) setCategory(categoryData);
        setLoading(false);
      }).catch(err => {
        console.error(err);
        setLoading(false);
      });
    }
  }, [adminId]);

  useEffect(() => {
    if (categoryid && adminId) {
      fetchSelectsubCategoryid(adminId, categoryid).then(data => {
        if (data) setSubCategoryd(data);
      });
    }
  }, [categoryid, adminId]);

  useEffect(() => {
    if (adminId && id) {
      setLoading(true);
      fetchProductIdAdmin(adminId, parseInt(id))
        .then(data => {
          if (data && data[0]) {
            const p = data[0];
            setProductCode(p.ProductCode || '');
            setProductName(p.Description || '');
            setTamilName(p.TamilFont || '');
            setCategoryid(p.CId || '');
            setSelectedCategory(p.SId || '');
            setMrp(p.MRP || '');
            setSaleRate(p.Price || '');
            setSelectedUOM(p.UnitType || 'Kgs');
            setMultiplePriceEnabled(
              p.MultiplePriceEnable === 1 ||
              p.MultiplePriceEnbled === 1 ||
              p.MultiplePriceEnabled === 1
            );
            setMultiplePriceList(sanitizeMultiplePriceList(p.ProductWeightType || []));
            setInStock(p.InStock === 1);
            setActiveStatus(p.Active === 1);
            setOfferProduct(p.OfferProduct === 1);
            setFeatureProduct(p.FeatureProduct === 1);
            setNewProduct(p.NewProduct === 1);
            setProductDescription(p.ProductDescription || '');
            setMainImage(p.Img0 ? p.Img0.replace('/productimages/', '') : null);
            setMainImagePreview(p.Img0 ? ImagePathRoutes.OfferProductImagePath + p.Img0.replace('/productimages/', '') : null);
            setAdditionalImage(p.Img1 ? p.Img1.replace('/productimages/', '') : null);
            setAdditionalImagePreview(p.Img1 ? ImagePathRoutes.OfferProductImagePath + p.Img1.replace('/productimages/', '') : null);
            setAdditionalImage1(p.Img2 ? p.Img2.replace('/productimages/', '') : null);
            setAdditionalImage1Preview(p.Img2 ? ImagePathRoutes.OfferProductImagePath + p.Img2.replace('/productimages/', '') : null);
            setReturnsavailability(p.ReturnsAvailability === 1);
            setReturnsavailabilityDate(p.ReturnPolicyDays || '');
            setAproximiate(p.Aproximiatedays || '');
            setOurchoice(p.OurChoice === 1);
            setBrandId(p.BrandId || null);
            setSelectedBrand(p.Brandname || '');
          }
        })
        .catch(err => {
          console.error('Error loading product:', err);
          // Don't show error for new products (when id exists but API fails)
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [adminId, id]);

  // Multiple Price Toggle Handler (same as jQuery)
  const handleMultiplePriceToggle = () => {
    if (multiplePriceEnabled) {
      setMultiplePriceEnabled(false);
      setOfferProduct(true);
    } else {
      setMultiplePriceEnabled(true);
      setOfferProduct(false);
      setFeatureProduct(false);
      setNewProduct(false);
    }
  };

  // Add Multiple Price Item
  const addMultiplePrice = () => {
    if (weightType && mrp2 && saleRate2) {
      const newItem = {
        Id: 0,
        WeightType: weightType,
        MRP: mrp2,
        SaleRate: saleRate2,
        gId: crypto.randomUUID()
      };
      setMultiplePriceList([...multiplePriceList, newItem]);
      setWeightType('');
      setMrp2('');
      setSaleRate2('');
    }
  };

  // Delete Multiple Price Item
  const deleteMultiplePrice = (gId) => {
    setMultiplePriceList(multiplePriceList.filter(item => item.gId !== gId));
  };

  // Handle image upload with preview
  const handleImageUpload = async (e, type) => {
    const file = e.target.files[0];
    if (file) {
      // Create preview URL immediately
      const previewUrl = URL.createObjectURL(file);
      
      // Set preview based on type
      if (type === "MainImage") {
        setMainImagePreview(previewUrl);
      } else if (type === "AdditionalImage") {
        setAdditionalImagePreview(previewUrl);
      } else if (type === "AdditionalImage1") {
        setAdditionalImage1Preview(previewUrl);
      }

      // Validate file type
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
      if (!allowedTypes.includes(file.type)) {
        alert('Please select a valid image file');
        return;
      }

      // Upload to server
      const formData = new FormData();
      formData.append("MyImages", file);
      setLoading(true);
      
      try {
        const response = await fetch(`${ServerURL.PRODUCTION_HOST_URL}/api/ItemMasterEcomApp/UploadFile`, {
          method: "POST",
          body: formData,
        });
        const data = await response.json();
        if (response.ok) {
          if (type === "MainImage") {
            setMainImage(data);
            // Keep preview as uploaded image URL if available
            setMainImagePreview(ImagePathRoutes.OfferProductImagePath + data);
          } else if (type === "AdditionalImage") {
            setAdditionalImage(data);
            setAdditionalImagePreview(ImagePathRoutes.OfferProductImagePath + data);
          } else if (type === "AdditionalImage1") {
            setAdditionalImage1(data);
            setAdditionalImage1Preview(ImagePathRoutes.OfferProductImagePath + data);
          }
        }
      } catch (error) {
        console.error("Error uploading image:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const getNormalizedPriceItems = () => {
    const normalized = sanitizeMultiplePriceList(multiplePriceList).map((item, index) => ({
      ...item,
      Id: item.Id || 0,
      PId: item.PId || 0,
      ItemMasterRefId: item.ItemMasterRefId || (id ? parseInt(id) : undefined),
      Sort: item.Sort || index,
    }));
    return normalized;
  };

  const handleSave = async (e) => {
    
    e.preventDefault();
    
    // Validation
    if (!productCode) {
      setErrorMessage("Enter Product Code");
      setIsErrorModalOpen(true);
      return;
    }
    if (!productName) {
      setErrorMessage("Enter Product Name");
      setIsErrorModalOpen(true);
      return;
    }
    if (!mrp) {
      setErrorMessage("Enter MRP");
      setIsErrorModalOpen(true);
      return;
    }
    if (!saleRate) {
      setErrorMessage("Enter Sale Rate");
      setIsErrorModalOpen(true);
      return;
    }
    if (!mainImage) {
      setErrorMessage("Upload Master Image");
      setIsErrorModalOpen(true);
      return;
    }
    const sanitizedMultiplePriceList = getNormalizedPriceItems();
    if (multiplePriceEnabled && sanitizedMultiplePriceList.length === 0) {
      setErrorMessage("Add Multiple Price values");
      setIsErrorModalOpen(true);
      return;
    }

    setSaving(true);
    
    const objlist = [{
      Id: id ? parseInt(id) : "",
      Comid: adminId,
      ProductCode: productCode,
      ProductName: productName,
      CategoryId: categoryid,
      SubCategoryId: selectedCategory || 0,
      PrintName: tamilName,
      MRP: mrp,
      SalesRate: saleRate,
      UOM: selectedUOM,
      ImagePath: mainImage,
      img1: AdditionalImage || "Undefined.jpg",
      img2: AdditionalImage1 || "Undefined.jpg",
      img3: "Undefined.jpg",
      img4: "Undefined.jpg",
      ProductDescription: productDescription,
      Sort: 0,
      IsStock: inStock ? 1 : 0,
      OfferProduct: multiplePriceEnabled ? 0 : (offerProduct ? 1 : 0),
      FeatureProduct: featureProduct ? 1 : 0,
      FreshProduct: featureProduct ? 1 : 0,
      NewProduct: multiplePriceEnabled ? 0 : (newProduct ? 1 : 0),
      MultiplePriceEnbled: multiplePriceEnabled ? 1 : 0,
      ProductWeightType: sanitizedMultiplePriceList,
      ActiveStatus: activeStatus ? 1 : 0,
      Aproximiatedays: AproximiateDate,
      ReturnsAvailability: returnsavailability ? 1 : 0,
      ReturnPolicyDays: returnsavailabilityDate,
      OurChoice: ourchoice ? 1 : 0,
      Brandname: selectedBrand,
      BrandId: BrandId ? parseInt(BrandId) : 0,
    }];

    try {
      const success = await insertProduct(objlist);
      if (success) {
        setSuccessMessage("Product saved successfully!");
        setIsSuccessModalOpen(true);
        setTimeout(() => navigate(`/AllProducts`), 1500);
      } else {
        setErrorMessage("Failed to save the Product.");
        setIsErrorModalOpen(true);
      }
    } catch (error) {
      setErrorMessage("An error occurred while saving.");
      setIsErrorModalOpen(true);
    } finally {
      setSaving(false);
    }
  };

  


  if (loading) {
    return (
      <div className="flex h-screen bg-gray-100">
        <div className="flex-shrink-0"><Slider /></div>
        <div className="flex-grow flex items-center justify-center">
          <div className="flex flex-col items-center gap-3">
            <div className="w-10 h-10 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
            <p className="text-gray-600 font-medium">Loading...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen bg-slate-100 text-slate-900">
      <div className="hidden xl:block xl:w-72 flex-shrink-0"><Slider /></div>

      <div className="flex-1 overflow-auto p-4 sm:p-6 lg:p-8">
        <div className="mx-auto max-w-7xl space-y-6">
          <section className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
            <div className="flex items-center justify-between">
              <h1 className="text-2xl font-semibold text-slate-900">{id ? 'Edit Product' : 'Add Product'}</h1>
            </div>
          </section>

          {isSuccessModalOpen && <SuccessModal message={successMessage} onClose={() => setIsSuccessModalOpen(false)} />}
          {isErrorModalOpen && <ErrorModal message={errorMessage} onClose={() => setIsErrorModalOpen(false)} />}

          <form onSubmit={handleSave} className="space-y-6">
            <div className="grid gap-6 lg:grid-cols-3">
              <section className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
                <div className="mb-4">
                  <h2 className="text-lg font-semibold text-slate-900">Basic Info</h2>
                  <p className="mt-1 text-sm text-slate-500">Enter product title, category and brand.</p>
                </div>
                <div className="space-y-4">
                  <Input label="Product Code" value={productCode} onChange={setProductCode} required icon={Tag} placeholder="Code" maxLength={15} />
                  <Input label="Product Name" value={productName} onChange={setProductName} required icon={Package} placeholder="Name" maxLength={100} />
                  {Comid !== 66 ? (
                    <Input label="Tamil Name" value={tamilName} onChange={setTamilName} icon={Tag} placeholder="Tamil" maxLength={50} />
                  ) : (
                    <Input label="Boxes & Pieces" value={tamilName} onChange={setTamilName} icon={Box} placeholder="Boxes" maxLength={50} />
                  )}
                  <Input
                    label={Comid === 66 ? "Youtube Video Link" : "Approximate delivery date"}
                    value={AproximiateDate}
                    onChange={setAproximiate}
                    icon={Tag}
                    placeholder={Comid === 66 ? "Paste YouTube link" : "e.g. 3-5 days"}
                    maxLength={100}
                  />
                  <Select label="Category" value={categoryid} onChange={setCategoryid} options={category} required icon={Layers} />
                  <Select label="SubCategory" value={selectedCategory} onChange={setSelectedCategory} options={dsubcategory} icon={Layers} />
                  <Select label="Brand" value={BrandId ? BrandId.toString() : ""} onChange={(val) => {
                    setBrandId(val ? parseInt(val) : null);
                    const brand = Brand.find(b => b.Id.toString() === val);
                    setSelectedBrand(brand ? brand.BrandName : "");
                  }} options={Brand} icon={Tag} />
                </div>
              </section>

              <section className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
                <div className="mb-4">
                  <h2 className="text-lg font-semibold text-slate-900">Pricing</h2>
                  <p className="mt-1 text-sm text-slate-500">Set pricing and inventory flags.</p>
                </div>
                <div className="space-y-4">
                  <Input label="MRP" value={mrp} onChange={setMrp} type="number" required icon={DollarSign} placeholder="0.00" maxLength={10} inputMode="decimal" />
                  <Input label="Sale Rate" value={saleRate} onChange={setSaleRate} type="number" required icon={DollarSign} placeholder="0.00" maxLength={10} inputMode="decimal" />
                  <Select label="UOM" value={selectedUOM} onChange={setSelectedUOM} options={['Kgs', 'Ml', 'Gr', 'Ltr', 'Piece', 'Pocket', 'Pack', 'Nos', 'Set', 'Roll'].map(u => ({ label: u, value: u }))} icon={Package} />
                  <div className="grid gap-3 sm:grid-cols-2">
                    <ToggleSwitch checked={returnsavailability} onChange={() => setReturnsavailability(!returnsavailability)} label="Returns Availability" />
                    <ToggleSwitch checked={activeStatus} onChange={() => setActiveStatus(!activeStatus)} label="Active" />
                    <ToggleSwitch checked={offerProduct} onChange={() => setOfferProduct(!offerProduct)} label={Comid === 66 ? "Kids Collection" : "Offer Product"} />
                    <ToggleSwitch checked={newProduct} onChange={() => setNewProduct(!newProduct)} label={Comid === 66 ? "Budget Blast" : "New Product"} />
                    <ToggleSwitch checked={featureProduct} onChange={() => setFeatureProduct(!featureProduct)} label={Comid === 66 ? "Night Crackers" : "Top Product"} />
                    <ToggleSwitch checked={ourchoice} onChange={() => setOurchoice(!ourchoice)} label={Comid === 66 ? "Day Crackers" : "Our Choice"} />
                  </div>
                  {returnsavailability && (
                    <div className="mt-3">
                      <label className="text-sm font-medium text-slate-700 block mb-2">Return Policy Days</label>
                      <input
                        type="text"
                        value={returnsavailabilityDate}
                        onChange={(e) => setReturnsavailabilityDate(e.target.value)}
                        placeholder="Enter return policy days"
                        className="w-full rounded-md border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-400"
                      />
                    </div>
                  )}
                </div>
              </section>

              <section className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
                <div className="mb-4">
                  <h2 className="text-lg font-semibold text-slate-900">Images</h2>
                  <p className="mt-1 text-sm text-slate-500">Add product photos for display.</p>
                </div>
                <div className="space-y-3">
                  <div className="rounded-xl border border-dashed border-slate-300 bg-slate-50 p-3">
                    <label className="text-sm font-medium text-slate-700">Main Image *</label>
                    <div className="mt-3 flex items-center gap-3">
                      <label className="inline-flex items-center gap-2 rounded-xl bg-slate-900 px-3 py-2 text-sm font-semibold text-white hover:bg-slate-800 cursor-pointer">
                        <Upload className="h-4 w-4" /> Choose file
                        <input type="file" className="hidden" accept="image/*" onChange={(e) => handleImageUpload(e, "MainImage")} />
                      </label>
                      <span className="text-sm text-slate-500 truncate max-w-[150px]">{mainImage || 'No file selected'}</span>
                    </div>
                    {mainImagePreview && (
                      <div className="mt-4 overflow-hidden rounded-xl border border-slate-200 bg-white">
                        <img src={mainImagePreview} alt="Main preview" className="h-24 w-full object-cover" />
                      </div>
                    )}
                  </div>
                  <div className="rounded-xl border border-dashed border-slate-300 bg-slate-50 p-3">
                    <label className="text-sm font-medium text-slate-700">Image 1</label>
                    <div className="mt-3 flex items-center gap-3">
                      <label className="inline-flex items-center gap-2 rounded-xl bg-slate-900 px-3 py-2 text-sm font-semibold text-white hover:bg-slate-800 cursor-pointer">
                        <Upload className="h-4 w-4" /> Choose file
                        <input type="file" className="hidden" accept="image/*" onChange={(e) => handleImageUpload(e, "AdditionalImage")} />
                      </label>
                      <span className="text-sm text-slate-500 truncate max-w-[150px]">{AdditionalImage || 'No file selected'}</span>
                    </div>
                    {additionalImagePreview && (
                      <div className="mt-4 overflow-hidden rounded-xl border border-slate-200 bg-white">
                        <img src={additionalImagePreview} alt="Additional preview 1" className="h-24 w-full object-cover" />
                      </div>
                    )}
                  </div>
                  <div className="rounded-xl border border-dashed border-slate-300 bg-slate-50 p-3">
                    <label className="text-sm font-medium text-slate-700">Image 2</label>
                    <div className="mt-3 flex items-center gap-3">
                      <label className="inline-flex items-center gap-2 rounded-xl bg-slate-900 px-3 py-2 text-sm font-semibold text-white hover:bg-slate-800 cursor-pointer">
                        <Upload className="h-4 w-4" /> Choose file
                        <input type="file" className="hidden" accept="image/*" onChange={(e) => handleImageUpload(e, "AdditionalImage1")} />
                      </label>
                      <span className="text-sm text-slate-500 truncate max-w-[150px]">{AdditionalImage1 || 'No file selected'}</span>
                    </div>
                    {additionalImage1Preview && (
                      <div className="mt-4 overflow-hidden rounded-xl border border-slate-200 bg-white">
                        <img src={additionalImage1Preview} alt="Additional preview 2" className="h-24 w-full object-cover" />
                      </div>
                    )}
                  </div>
                </div>
              </section>
            </div>

            <section className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
              <div className="mb-4">
                <h2 className="text-lg font-semibold text-slate-900">Description</h2>
                <p className="mt-1 text-sm text-slate-500">Add product details for customers.</p>
              </div>
              <textarea
                value={productDescription}
                onChange={(e) => setProductDescription(e.target.value)}
                placeholder="Describe the product..."
                className="min-h-[180px] w-full rounded-3xl border border-slate-300 bg-white px-4 py-3 text-sm text-slate-900 outline-none transition focus:border-blue-400 focus:ring-2 focus:ring-blue-100"
              />
            </section>

            <section className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
              <div className="mb-4 flex items-center justify-between">
                <div>
                  <h2 className="text-lg font-semibold text-slate-900">Multiple Prices</h2>
                  <p className="mt-1 text-sm text-slate-500">Enable only if this product has variant pricing.</p>
                </div>
                <ToggleSwitch checked={multiplePriceEnabled} onChange={handleMultiplePriceToggle} label="Enabled" />
              </div>
              {multiplePriceEnabled && (
                <div className="space-y-4">
                  <div className="grid gap-3 xl:grid-cols-4">
                    <Input label="Weight/Type" value={weightType} onChange={setWeightType} placeholder="e.g. 500g" maxLength={20} />
                    <Input label="MRP" value={mrp2} onChange={setMrp2} type="number" placeholder="0.00" maxLength={10} inputMode="decimal" />
                    <Input label="Sale Rate" value={saleRate2} onChange={setSaleRate2} type="number" placeholder="0.00" maxLength={10} inputMode="decimal" />
                    <div className="flex items-end">
                      <button type="button" onClick={addMultiplePrice} className="w-full rounded-xl bg-blue-600 px-4 py-3 text-sm font-semibold text-white transition hover:bg-blue-700">
                        <Plus className="inline-block h-4 w-4" /> Add
                      </button>
                    </div>
                  </div>
                  {multiplePriceList.length > 0 && (
                    <div className="overflow-x-auto rounded-xl border border-slate-200 bg-slate-50 p-3">
                      <table className="w-full text-sm text-slate-700">
                        <thead className="border-b border-slate-200 text-slate-600">
                          <tr>
                            <th className="px-3 py-2 text-left">S.No</th>
                            <th className="px-3 py-2 text-left">Weight Type</th>
                            <th className="px-3 py-2 text-left">MRP</th>
                            <th className="px-3 py-2 text-left">Sale Rate</th>
                            <th className="px-3 py-2 text-center">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {multiplePriceList && multiplePriceList.filter(Boolean).map((item, idx) => (
                            <tr key={item?.gId || idx} className="border-b border-slate-200">
                              <td className="px-3 py-3">{idx + 1}</td>
                              <td className="px-3 py-3">{item?.WeightType ?? '-'}</td>
                              <td className="px-3 py-3">{item?.MRP ?? '-'}</td>
                              <td className="px-3 py-3">{item?.SaleRate ?? '-'}</td>
                              <td className="px-3 py-3 text-center">
                                <button type="button" onClick={() => deleteMultiplePrice(item?.gId)} className="text-red-500 transition hover:text-red-700">
                                  <Trash2 className="h-4 w-4" />
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              )}
            </section>

            <div className="flex justify-end">
              <button type="submit" disabled={saving} className="inline-flex items-center gap-2 rounded-xl bg-gradient-to-r from-blue-600 to-blue-700 px-6 py-3 text-sm font-semibold text-white shadow-sm transition hover:from-blue-700 hover:to-blue-800 disabled:opacity-70">
                {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />}
                {saving ? 'Saving...' : 'Save Product'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddProductForm;